import { render } from "./MarketPlaceConfirmSection.vue?vue&type=template&id=40292c1a"
import script from "./MarketPlaceConfirmSection.vue?vue&type=script&lang=js"
export * from "./MarketPlaceConfirmSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__